<app-header *ngIf="!hideHeader"></app-header>
<div class="gateway-container">
  <router-outlet></router-outlet>
</div>
<app-footer *ngIf="!hideFooter"></app-footer>
